const state = {

    mindControlledUser: null,
    isRequesting: false,
}

export default state